var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVoices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 3.386,
  cy: 3.385,
  r: 1.881,
  stroke: "currentColor",
  strokeWidth: 0.903
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.386,
  cy: 8.651,
  r: 1.881,
  stroke: "currentColor",
  strokeWidth: 0.903
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.652,
  cy: 3.385,
  r: 1.881,
  stroke: "currentColor",
  strokeWidth: 0.903
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.652,
  cy: 8.651,
  r: 1.881,
  stroke: "currentColor",
  strokeWidth: 0.903
})));
export default SvgVoices;